import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.TrustThisDeviceHint', {
    tooltip: 'Your trusted device will be unbound if you either change your password or disable 2FA on your account.',
});
